import { useSelector, useDispatch } from 'react-redux';
import { SemanticUI } from '@iterable/deprecated_react_components';
import { Tooltip } from 'ui/tooltip';
import { redoQuery, toggleEditMode, toggleViewMode, undoQuery } from '../../actions';
import { selectCanRedo, selectCanUndo } from '../../selectors';
import {
  StyledCoreDockingBar,
  StyledCoreButtonGroup,
  StyledCoreButton,
  StateButtonsContainer,
} from './StateButtons.styled';

const DATA_TEST = {
  edit: 'edit-mode-button',
  read: 'read-mode-button',
  undo: 'undo-change-button',
  redo: 'redo-change-button',
};

// type Props = {
//   /** Whether user can edit the query builder */
//   canEdit: boolean,
//   /** [PRO-3634] `displayContent` convention for localization. Turn text to translate into a localization en-US.json */
//   content?: {
//     editButtonText: string,
//     readButtonText: string,
//     redoButtonText: tring,
//     undoButtonText: string,
//   },
//   /** whether the view mode or edit mode is visible */
//   isViewMode: boolean,
// };

// TODO: [PRO-3634] `displayContent` convention for localization. Turn text to translate into a localization en-US.json
export const displayContent = {
  editButtonText: 'Edit',
  readButtonText: 'Read',
  redoButtonText: 'Redo',
  undoButtonText: 'Undo',
};

export const StateButtons = ({ canEdit = true, content = displayContent, isViewMode = false }) => {
  const dispatch = useDispatch();

  /** If undo action is allowed. Enables undo button. */
  const canUndo = useSelector(selectCanUndo);
  /** If redo action is allowed. Enables redo button. */
  const canRedo = useSelector(selectCanRedo);

  const handleUndo = () => dispatch(undoQuery());
  const handleRedo = () => dispatch(redoQuery());
  const handleToggleViewMode = () => dispatch(toggleViewMode());
  const handleToggleEditMode = () => dispatch(toggleEditMode());

  return (
    <StyledCoreDockingBar dockedClassName="cssStateButtonsDocked" dockOnTop>
      <StateButtonsContainer data-test="query-builder-state-buttons">
        <StyledCoreButtonGroup>
          <StyledCoreButton
            data-test={DATA_TEST.edit}
            disabled={!canEdit}
            onClick={handleToggleEditMode}
            selected={!isViewMode}
            table
          >
            {content.editButtonText}
          </StyledCoreButton>
          <StyledCoreButton
            data-test={DATA_TEST.read}
            onClick={handleToggleViewMode}
            selected={isViewMode}
            table
          >
            {content.readButtonText}
          </StyledCoreButton>
        </StyledCoreButtonGroup>
        <StyledCoreButtonGroup>
          <Tooltip isEnabled={canUndo} tooltipContent={content.undoButtonText}>
            <StyledCoreButton
              icon
              data-test={DATA_TEST.undo}
              disabled={!canUndo}
              onClick={handleUndo}
              table
            >
              <SemanticUI.Icon name="undo" />
            </StyledCoreButton>
          </Tooltip>
          <Tooltip isEnabled={canRedo} tooltipContent={content.redoButtonText}>
            <StyledCoreButton
              icon
              data-test={DATA_TEST.redo}
              disabled={!canRedo}
              onClick={handleRedo}
              table
            >
              <SemanticUI.Icon name="redo" />
            </StyledCoreButton>
          </Tooltip>
        </StyledCoreButtonGroup>
      </StateButtonsContainer>
    </StyledCoreDockingBar>
  );
};
